import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";

import { DEFAULT_VALUES } from "@/components/features/design/plain/model/constants";
import type * as FormModelType from "@/components/features/design/plain/model/type";

/**
 * InputModel の初期値を生成
 * @param hotelID
 * @returns FormModelType.PlainSettingFormModel["InputModel"]
 */
export const plainSettingInputModelFactory = (hotelID: string): FormModelType.PlainSettingFormModel["InputModel"] =>
	({
		hotelID,
		// URL 設定
		domainName: "",
		subDomainName: "",

		// 色の設定
		colorBackground: DEFAULT_VALUES.colorBackground,
		colorFont: DEFAULT_VALUES.colorFont,
		colorPrimary: DEFAULT_VALUES.colorPrimary,

		// 施設情報の設定
		isShowHotelName: false,
		isShowHotelCatchCopy: false,
		isShowHotelLogo: true,
		logoSize: DEFAULT_VALUES.logoSize,
		isShowHotelKeyVisual: false,

		// フォント設定
		fontFamily: DEFAULT_VALUES.fontFamily,

		// ReservationComponent の設定
		reservationComponentType: DEFAULT_VALUES.reservationComponentType,

		// スナックの設定
		plainWidgetDefault: {
			hotelID,
			widgetItems: [],
		},
		widgetDecoration: DEFAULT_VALUES.widgetDecoration,

		//
		backgroundType: DEFAULT_VALUES.backgroundType,
		backgroundImage: undefined,
		reservationComponentViewerOrder: undefined,

		// 検索エンジンへの表示（レコードがないときのサーバーの値と同じ未設定）
		guestPageVisibility: GuestPageVisibilityMode.Unset,
	}) satisfies FormModelType.PlainSettingFormModel["InputModel"];
